import { render } from "./ClientConfigOptionEdit.vue?vue&type=template&id=1555923a"
import script from "./ClientConfigOptionEdit.vue?vue&type=script&lang=js"
export * from "./ClientConfigOptionEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__